import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import MobileSidebar from './MobileSidebar';
import { RESPONSIVE_BREAKPOINT } from '../../utils/constants';
import { getSidebarCollapsed } from '../../utils/storageUtils';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: white;
`;

const MainContent = styled.div<{ $sidebarCollapsed?: boolean }>`
  flex: 1;
  margin-left: ${props => props.$sidebarCollapsed ? '0px' : '280px'};
  min-height: 100vh;
  transition: margin-left 0.25s ease;

  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    margin-left: 0;
    margin-top: 64px;
  }
`;

const ContentWrapper = styled.div<{ $sidebarCollapsed?: boolean }>`
  padding: 32px;
  max-width: ${props => props.$sidebarCollapsed ? '100%' : '1450px'};
  margin: 0 auto;
  overflow-x: hidden;
  width: 100%;
  transition: max-width 0.25s ease;

  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    padding: 16px;
  }
`;

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(getSidebarCollapsed);

  return (
    <>
      <MobileSidebar />
      <LayoutContainer>
        <Sidebar collapsed={sidebarCollapsed} onCollapsedChange={setSidebarCollapsed} />
        <MainContent $sidebarCollapsed={sidebarCollapsed}>
          <ContentWrapper $sidebarCollapsed={sidebarCollapsed}>{children}</ContentWrapper>
        </MainContent>
      </LayoutContainer>
    </>
  );
};

export default DashboardLayout; 